import axios from "axios";
import store from 'store'

export const getAccounts = () => {
    let accounts = store.get('bomb_accounts') || [];
    if (accounts) {
        return accounts;
    } else {
        return [];
    }
}


export const getAccountResult = (account) => {
    return axios({
        method: 'get',
        url: `https://claim.bombcrypto.io/claim-orders?&limit=100&offset=0&walletAddress=${account}`,
    })
        .then(function (response) {
            return response.data
        })
        .catch((error) => {
            console.log(error);
        });
}


export const createAccount = (address) => {
    return {
        address: address,
        amount_of_bcoin: 0,
        amount_of_bcoin_claimed: 0,
        amount_of_bcoin_funding: 0,
        amount_of_fee: 0,
        roi: null,
        lasted_claimed: 0,
        heroes: [],
        items: [],
    }
}

export const getTransaction = (address) => {
    return axios({
        method: 'get',
        url: `https://api.apeboard.finance/transaction-history/bsc/${address}`,
        headers: {
            'authority': 'api.apeboard.finance',
            'pragma': 'no-cache',
            'cache-control': 'no-cache',
            'accept': 'application/json, text/plain, */*',
            'ape-secret': 'U2FsdGVkX18JVWufTJaeqshvFh4Bj+Smk0H79+0ZOB24my4hLICsPQ/tmAwS9PACacOppr3bg6OEcW6H1wT2fMOoiyJT5OGveTVwCBautEVzdKCENAIcRVNFhw4fleQ3bqx/+ui3PM+/kDaFQWrSodT/W4sc9CnJPprasB56Qlc=',
            'passcode': 'A63uGa8775Ne89wwqADwKYGeyceXAxmHL',
            'accept-language': 'en-US,en;q=0.9'
        }
    })
        .then(function (response) {
            return response.data
        })
        .catch((error) => {
            console.log(error);
        });
}
